import { useState } from "react";

import Volume_Performance_Realization from "./volume_performance_realization";
import RealizationComparision from "./RealizationComparison";

const RealizationComparisionCombined = ({ show }) => {
  const [isTreemap, setIsTreemap] = useState(true);

  const handleToggle = () => {
    setIsTreemap(!isTreemap);
  };

  return (
    <div className="relative  bg-white rounded-md md:w-full w-[416px]  h-full">
      {!show && (
        <div className="absolute top-2 right-4  gap-1 flex items-center z-10">
          <span className="mr-2 text-gray-700 md:text-sm text-[11px]">
            {isTreemap
              ? "Realization MoM Comparison"
              : "Realization as % of list price"}
          </span>
          <label className="relative inline-block w-10 align-middle select-none">
            <input
              type="checkbox"
              checked={isTreemap}
              onChange={handleToggle}
              className="toggle-checkbox absolute block w-6 h-6 rounded-full appearance-none cursor-pointer border-2 border-transparent transition-transform duration-200"
            />
            <span
              className={`toggle-label block overflow-hidden h-6 rounded-full cursor-pointer ${
                isTreemap ? "bg-[#AAE0D3]" : "bg-[#b9b8f4]"
              }`}
            >
              <span
                className={`block h-5 w-5 rounded-full ${
                  isTreemap ? "bg-[#599f8e]" : "bg-[#8381fe]"
                } shadow-md transform transition-transform duration-200 ${
                  isTreemap ? "translate-x-full" : "translate-x-0"
                } translate-y-0.5`}
              ></span>
            </span>
          </label>
        </div>
      )}
      <div>
        {isTreemap ? (
          <Volume_Performance_Realization />
        ) : (
          <RealizationComparision />
        )}
      </div>
    </div>
  );
};
export default RealizationComparisionCombined;
